<template>
    <section>
        <div>
            <form @submit.prevent="findAccount" novalidate>    
            <div class="t-body3 mgt-6 t-color-content1" v-html="$t('38', {str: `<strong class='t-color-title'>${findId.step3.value}</strong>`})">
                 <!-- <span class="bold">{{findId.step3.value}}</span>로 전송된 <span class="bold t-color-red1">코드6자리</span>를 입력하시면
            계정을 확인하실 수 있습니다. -->
            </div>
            <div class="mgt-38">
                <div class="mdc-text-field mdc-text-field--outlined w-full"
                    :class="submitState && certiNumberInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="certiNumberEl"
                >
                    <input type="number" class="mdc-text-field__input"
                        id="certiNumber"
                        name="certiNumber"
                        v-model="certiNumber"
                        v-validate="'required|numeric|length:6'"
                        ref="certiNumber"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('39')}}                        
                            <!-- 6자리의 코드 입력 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && certiNumberInvalidCheck">
                        {{$t('9')}}
                        <!-- * 전송된 인증번호 6자리를 입력해주세요. -->
                    </span>
                </div>
                
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('40')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindId()" type="button">
                    {{$t('41')}}
                <!-- 취소 -->
                </button>
            </div>
            </form>

            <div class="mgt-30 t-body4 t-color-gray1">
                <a @click="showMessage(1)">
                    {{$t('42')}}
                    <!-- 코드를 받지 못하셨나요? -->
                </a>
                {{$t('43')}}
                <!-- 혹은 -->
                <a @click="showMessage(2)">
                    {{$t('44')}}
                    <!-- 사용할 수 없는 번호인가요? -->
                </a>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 계정 찾기 Step4 컴포넌트 (find account Step4 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '../../mixins/findId.js'

export default {
    data() {
        return {
            certiNumber: '',
            certiNumberTextField: null,
            submitState: false
        }
    },

    mixins: [findIdMixin],

    computed: {
        ...mapState('findId',{
            findId : state => state,
        }),

        // 인증번호 유효성 체크(validation check certiNumber)
        certiNumberInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('certiNumber')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }

            this.certiNumberTextField.valid === !returnValue ? '' : this.certiNumberTextField.valid = !returnValue
            return returnValue
        }
    },

    mounted() {
        // 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
        if (!this.findId.step3.token) {
            this.$moveLogin()
        }
        this.setMaterialUi()
        this.$refs.certiNumber.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findId', ['SET_STEP2','SET_STEP3','SET_LOGINID']),

        setMaterialUi() {
            this.certiNumberTextField = new MDCTextField(document.querySelector('#certiNumberEl'))
            this.certiNumberTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 인증번호 발송 API 호출(Authentication number sending API call)
        getReCertiNumber() {
            
            let params = this.findId.step2            
            let responseData = null

            // set certi number
            findApi.requestFindId(params).then((response) => {
                responseData = response.data.data
                this.SET_STEP3({
                    value: this.findId.step2.value,
                    token: responseData.token
                })

                this.$router.push({
                    name: 'FindIdStep4'
                })
            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
            })
        },

        // 계정찾기 위한 인증번호 확인(check certiNumber)
        findAccount() {

            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let params = {
                        token: this.findId.step3.token,
                        value: this.certiNumber
                    }

                    let responseData = null

                    findApi.findId(params).then((response) => {
                        responseData = response.data.data
                        console.log(responseData.loginId)

                        this.SET_LOGINID(responseData.loginId)
                        this.$router.push({
                            name: 'FindIdComplete'
                        })

                    }).catch((err) => {
                        responseData = err.response.data.meta
                        // this.errorModal({title:'잘못된 코드', content: '코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
                        // this.$snackOpen({contents:'코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
                        this.$snackOpen({
                            contents: this.$t('52') +' '+ this.$t('53'),
                            btnDisplayYN: false,
                            btnDisplay:this.$t('Common.00001')
                        }).then(() => {})

                    })
                }else {
                    this.$refs.certiNumber.focus()
                }
            })
        }
    },

}
</script>